<template>
    <header
        class="tc"
        style="
            background-color: #fff;
            box-shadow: 0 2px 10px #eee;
            position: sticky;
            top: 0;
            z-index: 1000;
        "
    >
        <div class="w1200 dib h70">
            <div class="kkgaw8cv-nav">
                <a href="/" class="dib vm mr50 kkgmzsb4-logo">
                    <img src="@/assets/img/main-logo.png" alt="" />
                </a>
                <ul class="nav-list dib mr40">
                    <li v-for="(item, index) in nav" :key="index">
                        <template v-if="index == 1 && !(proNav.length)">
                            <span>
                                <a
                                    :href="item.path"
                                    class="fs16"
                                    :class="navIndex === index ? 'active' : ''"
                                    @click="routerLink(index)"
                                    v-html="item.title"
                                ></a>
                            </span>
                        </template>
                        <template v-else>
                            <el-dropdown :show-timeout="150">
                                <span class="el-dropdown-link">
                                    <a
                                        :href="item.path"
                                        class="fs16"
                                        :class="
                                            navIndex === index ? 'active' : ''
                                        "
                                        @click="routerLink(index)"
                                        v-html="item.title"
                                    ></a>
                                    <i
                                        v-if="index == 2 || index == 1"
                                        class="el-icon-arrow-down el-icon--right c_theme fs12"
                                    ></i>
                                </span>
                                <!-- 这里菜单栏使用v-if会报错 所以采用class的方式将其隐藏 -->
                                <el-dropdown-menu
                                    slot="dropdown"
                                    :class="
                                        index == 2 || index == 1 ? '' : 'vh'
                                    "
                                >
                                    <template v-if="index == 2">
                                        <el-dropdown-item
                                            v-for="(item, index) in secondNav"
                                            :key="index"
                                            :class="
                                                secondIndex === index
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <a
                                                :href="item.path"
                                                class="fs16 dbi"
                                                >{{ item.title }}</a
                                            >
                                        </el-dropdown-item>
                                    </template>
                                    <template v-else-if="index == 1">
                                        <el-dropdown-item
                                            v-for="(item, index) in proNav"
                                            :key="index"
                                            :class="
                                                proIndex === index
                                                    ? 'active'
                                                    : ''
                                            "
                                        >
                                            <a
                                                :href="item.path"
                                                class="fs16 dbi"
                                                >{{ item.title }}</a
                                            >
                                        </el-dropdown-item>
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </li>
                </ul>
                <div class="dib kkglvxdr-search">
                    <form
                        action="/product"
                        @submit.prevent="subSearch"
                        ref="searchForm"
                    >
                        <el-input
                            :placeholder="ast.klhu1jxl_input.body[0].value"
                            name="proSearch"
                            v-model="index_topSearch"
                            class="input-with-select"
                        >
                            <el-button
                                slot="append"
                                icon="el-icon-search"
                                @click="subSearch"
                            ></el-button>
                        </el-input>
                    </form>
                </div>
                <div class="dib kkgm9kop-change">
                    <a
                        :href="ast.klfznyad_cn.attributeMap.href.value.value"
                        class="db fs12"
                        >{{ ast.klfznyad_cn.body[0].value }}</a
                    >
                    <a
                        :href="ast.klfzo7aa_en.attributeMap.href.value.value"
                        class="db fs12"
                        >{{ ast.klfzo7aa_en.body[0].value }}</a
                    >
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: "kl_include_header",
    data() {
        return {
            index_topSearch: "",
            nav: [],
            // 二级导航
            secondNav: [],
            navIndex: 0,
            // 二级导航索引
            secondIndex: 0,
            // 产品二级导航
            proNav: [],
            proIndex: 0,
        };
    },
    created() {
        // 导航
        this.ast.kkfj5ie2_header.body[0].body.forEach((item) => {
            this.nav.push({
                title: item.body[0].value,
                path: item.attributeMap.href.value.value,
            });
        });
        // 二级导航
        this.ast.kkrzluu8_mlj.body.forEach((item) => {
            this.secondNav.push({
                title: item.body[0].value,
                path: item.attributeMap.href.value.value,
            });
        });
        // 产品二级导航
        this.ast.kkrzluu8_pro.body.forEach((item) => {
            this.proNav.push({
                title: item.body[0].value,
                path: item.attributeMap.href.value.value,
            });
        });
        // 获取当前路径
        let path = this.$route.path;
        // 检索当前路径-激活当前nav
        this.checkRouterLocal(path);
        this.checkSecondNav(path);
    },
    computed: {},
    methods: {
        // 路由跳转
        routerLink() {
            // this.navIndex = index;
            // this.$router.push(path)
        },
        checkRouterLocal(path) {
            // 目录集 子目录激活导航高亮
            if (/^\/name|cas|glossary.*/.test(path) || /^\/cas.*/.test(path)) {
                path = "javascript:void(0);";
            }
            // 关于我们 子目录激活导航高亮
            if (/^\/aboutus.*/.test(path)) {
                path = "/aboutus";
            }
            // 技术问答 子目录激活导航高亮
            if (/^\/technicalqa.*/.test(path)) {
                path = "/technicalqa";
            }
            // 新闻资讯 子目录激活导航高亮
            if (/^\/news.*/.test(path)) {
                path = "/news";
            }
            // 产品 子目录激活导航高亮
            if (/^\/product.*/.test(path)) {
                path = "/product";
            }
            // 查找当前路由下标高亮
            this.navIndex = this.nav.findIndex((item) => item.path === path);
        },
        // 二级导航激活状态
        checkSecondNav(path) {
            if (/^\/name.*/.test(path)) {
                path = "/name_list";
            }
            if (/^\/cas.*/.test(path)) {
                path = "/cas_list1";
            }
            if (/^\/glossary.*/.test(path)) {
                path = "/glossary1";
            }
            this.secondIndex = this.secondNav.findIndex(
                (item) => item.path === path
            );
            this.proIndex = this.proNav.findIndex((item) => item.path === path);
        },
        // 提交搜索
        subSearch() {
            if (this.index_topSearch == "") {
                return;
            } else {
                this.$refs.searchForm.submit();
            }
        },
    },
};
</script>

<style lang="less">
@import (reference) "@/assets/less/base.less";
// reset 二级导航 激活状态
.el-dropdown-menu {
    .active {
        background-color: #d7f1f4;
    }
}
.el-dropdown-menu--small .el-dropdown-menu__item {
    padding: 0;
    a {
        padding: 0 15px;
        font-family: "Arial", "Microsoft Yahei", "PingFang SC", "Verdana",
            "Helvetica Neue", "Hiragino Sans GB", "Microsoft Sans Serif",
            "WenQuanYi Micro Hei", "sans-serif";
    }
}
// 导航列表
.kkgaw8cv-nav {
    // logo 防止闪烁-为其设置初始宽度
    font-family: "Arial", "Microsoft Yahei", "PingFang SC", "Verdana",
        "Helvetica Neue", "Hiragino Sans GB", "Microsoft Sans Serif",
        "WenQuanYi Micro Hei", "sans-serif";
    .kkgmzsb4-logo {
        width: 139px;
        height: 36px;
        .pr;
        top: -4px;
    }
    margin-top: 15px;
    .nav-list {
        li {
            .dib;
            margin: 0 20px;
            a {
                .dib;
                padding: 5px 3px;
                color: @c_theme;
                &:hover {
                    color: @a_hover;
                }
            }
            .active {
                color: @a_hover;
                border-bottom: 2px solid @a_hover;
                .fwb;
            }
        }
    }
    // element input reset
    .kkglvxdr-search {
        .el-input__inner {
            width: 270px;
            background-color: #f4f4f4;
            border: 1px solid #f4f4f4;
            height: 38px;
        }
        .el-input-group__append {
            color: #fff;
            background-color: @c_theme;
            border: 1px solid @c_theme;
            width: 20px;
        }
        .el-icon-search {
            .fs16;
        }
    }
    // 中英文切换
    .kkgm9kop-change {
        line-height: 20px;
        vertical-align: middle;
        margin-left: 15px;
        position: relative;
        top: -5px;
        text-align: left;
        color: #666;
        cursor: pointer;
    }
}
</style>
